import React, { useContext, useEffect, useState } from "react";
import Header from "../../../Components/comman/Header";
import { Button, Tab } from "react-bootstrap";
import SideMenu from "../SideMenu";
import { Auth } from "../../../Contexts/AuthContext";
import Stepper from "../../../Components/Stepper";
import Images from "../../../Helpers/Images";
import MobileHeader from "../../../Components/comman/MobileHeader";
import Aos from "aos";
import CustomLoader from "../../../Components/comman/Loader/CustomLoader";
import { useNavigate } from "react-router-dom";
const BrandDashboard = () => {
  const[isLoading , setIsLoading] = useState(false);
  const { auth } = useContext(Auth);
  const navigate = useNavigate();
  useEffect(() => {
    Aos.init({});
  }, []);
  return (
    <div className="brand-dashboard-wrapper">
      <Header />
      <MobileHeader />
     
      <div className="brand-dashboard-inner ">
        <Tab.Container activeKey={`dashboard`}>
          <SideMenu />
          <CustomLoader visible={isLoading} />
          <div className="brand-dashboard-content-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"dashboard"}>
                <div className="brand-home-wrapper">
                  <section className="top-heading-wrapper">
                    <div
                      className="welcome-box box"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <span>
                        Hello, <span>{auth.user?.owner_name}</span>
                      </span>
                      <p>
                        Welcome to your brand dashboard. Here you can find
                        everything you need to help you get started with
                        influencer marketing and track your campaigns.
                      </p>
                     
                    </div>
                    <div
                      className="camp-highlight-box  box"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Your Brand Highlights</h4>
                      <div className="company-info">
                        <p className="company">{auth.user?.brand_name}</p>
                        <a className="website">{auth.user?.website}</a>
                      </div>
                      {/* <div>
                        <h6>
                          Campaign Specialist : <span>None</span>
                        </h6>
                        <p className="campagin-number">
                          <span>0</span> campaigns
                        </p>
                      </div> */}
                    </div>
                  </section>
                  <section className="process-wrapper">
                    <Stepper />
                  </section>
                  <section className="success-team-wrapper">
                    <h3>Meet Your Success Team</h3>
                    <p>
                      We help some of the world's top brands build and execute
                      <br /> successful creator strategies.
                    </p>
                    <div className="profile-card">
                      <div
                        className="box1 box"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                      >
                        <img src={Images.card1} alt="card-img" />
                        <div className="overlay">
                          <p>Liza Tris</p>
                        </div>
                      </div>
                      <div
                        className="box2 box"
                        data-aos="fade-down"
                        data-aos-duration="1500"
                      >
                        <img src={Images.card2} alt="card-img" />
                        <div className="overlay">
                          <p>Nathan Braken</p>
                        </div>
                      </div>
                      <div
                        className="box3 box"
                        data-aos="fade-up"
                        data-aos-duration="2000"
                      >
                        <img src={Images.card3} alt="card-img" />
                        <div className="overlay">
                          <p>Elis Perry</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
};

export default BrandDashboard;
